import {Component} from '@angular/core';
import {FieldArrayType} from '@ngx-formly/core';

@Component({
  selector: 'formly-repeat-section',
  styleUrls: ['repeat-section.component.css'],
  template: `
    <div *ngFor="let fl of field.fieldGroup; let i = index">
      <strong *ngIf="field?.key != 'documentList'">
        {{ props?.innerLabel }} {{ i + 1 }}</strong
      >
      <strong *ngIf="field?.key == 'documentList'"
        >{{ model[i]?.docId | filterList: props?.options
        }}<span *ngIf="model[i]?.isNotMandatory != 'Y'"> * </span>
        <span *ngIf="model[i]?.regCmpDocId && model[i]?.isLocked == 0"
          >(by Auditor)</span
        ></strong
      >
      <formly-field [field]="fl"></formly-field>
    </div>
  `,
})
export class RepeatTypeComponent extends FieldArrayType {}
